import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

export default function Inregistrare() {
  const [form, setForm] = useState({
    numeFirma: '', cui: '', persoanaContact: '',
    telefon: '', email: '', adresa: '', mesaj: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [acceptaConfidentialitate, setAcceptaConfidentialitate] = useState(false);
  const [acceptaTermeni, setAcceptaTermeni] = useState(false);
  const navigate = useNavigate();

  const poateTrimite = acceptaConfidentialitate && acceptaTermeni;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!poateTrimite) {
      setError('Pentru a trimite cererea, trebuie să confirmați că ați citit și sunteți de acord cu Politica de confidențialitate și cu Termenii și condițiile.');
      return;
    }
    setError(''); setLoading(true);
    try {
      const res = await fetch('https://manager.softconsult.ro/api/public/cerere', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      let data = {};
      try { data = await res.json(); } catch(_) {}
      if (!res.ok) throw new Error(data.error || 'Eroare server (' + res.status + ')');
      setSuccess(true);
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const f = (field, label, type='text', required=false) => (
    <div className="form-group">
      <label>{label}{required && <span style={{color:'#e74c3c'}}> *</span>}</label>
      <input type={type} value={form[field]} onChange={e=>setForm({...form,[field]:e.target.value})}
        required={required} />
    </div>
  );

  if (success) return (
    <div className="page-with-footer">
      <div className="page-body">
        <div className="login-page">
          <div className="login-box" style={{textAlign:'center'}}>
            <div style={{fontSize:48,marginBottom:16}}>✅</div>
            <h2 style={{color:'#27ae60',marginBottom:8}}>Cerere trimisă!</h2>
            <p style={{color:'#555',marginBottom:20}}>
              Cererea dumneavoastră a fost primită. Veți fi contactat în cel mai scurt timp posibil.
            </p>
            <p style={{fontSize:12,color:'#888',marginBottom:20}}>
              Un email de confirmare a fost trimis la: <b>{form.email}</b>
            </p>
            <button className="login-submit" onClick={()=>navigate('/login')}>
              ← Înapoi la login
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );

  return (
    <div className="page-with-footer">
      <div className="page-body">
        <div className="login-page" style={{alignItems:'flex-start',paddingTop:40}}>
          <div className="login-box" style={{width:480,maxWidth:'96vw'}}>
            <div className="login-logo">
              <h2>🚛 Monitorizare Flotă</h2>
              <p style={{color:'#888',fontSize:12,marginBottom:20}}>Înregistrare client nou</p>
            </div>

            {error && <div className="login-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              {f('numeFirma','Denumire firmă','text',true)}
              {f('cui','CUI / CIF')}
              {f('persoanaContact','Persoană de contact','text',true)}
              {f('telefon','Telefon')}
              {f('email','Email contact','email',true)}
              {f('adresa','Adresă firmă')}
              <div className="form-group">
                <label>Mesaj / Informații suplimentare</label>
                <textarea value={form.mesaj} onChange={e=>setForm({...form,mesaj:e.target.value})}
                  rows={3} style={{width:'100%',padding:'8px',border:'1px solid #ccc',borderRadius:4,fontSize:12}}
                  placeholder="Nr. vehicule, tip activitate..."/>
              </div>

              <div className="consent-box">
                <div className="consent-row">
                  <input type="checkbox" id="acceptaConfidentialitate"
                    checked={acceptaConfidentialitate}
                    onChange={e=>setAcceptaConfidentialitate(e.target.checked)} />
                  <label htmlFor="acceptaConfidentialitate">
                    Am citit și sunt de acord cu{' '}
                    <a href="/confidentialitate" target="_blank" rel="noopener noreferrer">
                      Politica de confidențialitate
                    </a>, inclusiv cu privire la backup-ul zilnic și la exonerarea de răspundere
                    pentru pierderea datelor în urma atacurilor cibernetice.
                  </label>
                </div>
                <div className="consent-row">
                  <input type="checkbox" id="acceptaTermeni"
                    checked={acceptaTermeni}
                    onChange={e=>setAcceptaTermeni(e.target.checked)} />
                  <label htmlFor="acceptaTermeni">
                    Am citit și sunt de acord cu{' '}
                    <a href="/termeni" target="_blank" rel="noopener noreferrer">
                      Termenii și condițiile
                    </a>, inclusiv cu faptul că aplicația este gratuită în limita unui singur
                    utilizator și a unui singur autovehicul, iar întreaga răspundere pentru
                    pierderea datelor cade în sarcina utilizatorului.
                  </label>
                </div>
              </div>

              <button className="login-submit" type="submit" disabled={loading || !poateTrimite}>
                {loading ? 'Se trimite...' : '📩 Trimite cererea'}
              </button>
            </form>

            <div style={{textAlign:'center',marginTop:14}}>
              <a href="/login" style={{fontSize:12,color:'#2d6ca2'}}>← Înapoi la login</a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
